import { Api } from "api";
import type {
  CallFeedbackDetail,
  CallFeedbackListResponse,
  CallFeedbackStats,
} from "types/call-feedback-type";

const BASE = "/calls/v1/feedback";

export async function getFeedbackById(id: string): Promise<CallFeedbackDetail> {
  const res = await Api.get<CallFeedbackDetail>(`${BASE}`, { params: { id } });
  return res.data;
}

export type ListFeedbackParams = {
  user_id?: string;
  rating?: number;
  limit?: number;
  offset?: number;
};

export async function listFeedback(
  params: ListFeedbackParams = {}
): Promise<CallFeedbackListResponse> {
  const res = await Api.get<CallFeedbackListResponse>(`${BASE}/list`, {
    params: {
      user_id: params.user_id || undefined,
      rating: params.rating ?? undefined,
      limit: params.limit ?? 20,
      offset: params.offset ?? 0,
    },
  });
  return res.data;
}

export async function getFeedbackStats(): Promise<CallFeedbackStats> {
  const res = await Api.get<CallFeedbackStats>(`${BASE}/stats`);
  return res.data;
}
